{
  "source": "OEB RPP 2025-11-01..2026-10-31 (supply ¢/kWh constant over window); summer windows effective 2026-05-01; OEB + Toronto Hydro residential rate pages",
  "as_of": "2026-06-03",
  "currency": "CAD_cents_per_kWh",
  "note": "RPP supply prices already BUNDLE the Global Adjustment — never add GA on top. OER is a bill-total rebate only, not a marginal signal (oerPercent unused by priceAt).",
  "summerMonths": [5, 6, 7, 8, 9, 10],
  "domainSeasonConfig": { "winter": "winter", "spring": "winter", "summer": "summer", "fall": "summer" },
  "plans": {
    "TOU": {
      "prices": { "off": 9.8, "mid": 15.7, "on": 20.3 },
      "windows": {
        "summer": {
          "on": ["WEEKDAY 11:00-17:00"],
          "mid": ["WEEKDAY 07:00-11:00", "WEEKDAY 17:00-19:00"],
          "off": ["19:00-07:00", "WEEKEND", "HOLIDAY"]
        },
        "winter": {
          "on": ["WEEKDAY 07:00-11:00", "WEEKDAY 17:00-19:00"],
          "mid": ["WEEKDAY 11:00-17:00"],
          "off": ["19:00-07:00", "WEEKEND", "HOLIDAY"]
        }
      },
      "defaultPeriod": "off"
    },
    "ULO": {
      "prices": { "overnight": 3.9, "weekendOff": 9.8, "mid": 15.7, "on": 39.1 },
      "windows": {
        "summer": {
          "overnight": ["23:00-07:00"],
          "on": ["WEEKDAY 16:00-21:00"],
          "mid": ["WEEKDAY 07:00-16:00", "WEEKDAY 21:00-23:00"],
          "weekendOff": ["WEEKEND 07:00-23:00", "HOLIDAY 07:00-23:00"]
        },
        "winter": {
          "overnight": ["23:00-07:00"],
          "on": ["WEEKDAY 16:00-21:00"],
          "mid": ["WEEKDAY 07:00-16:00", "WEEKDAY 21:00-23:00"],
          "weekendOff": ["WEEKEND 07:00-23:00", "HOLIDAY 07:00-23:00"]
        }
      },
      "defaultPeriod": "overnight"
    },
    "TIERED": {
      "prices": { "t1": 12.0, "t2": 14.2 },
      "thresholdKWhPerMonth": { "summer": 600, "winter": 1000 },
      "marginalPeriod": "t1"
    }
  },
  "signalThresholds": {
    "_note": "Battery charge/discharge gates (build log 45 value model). cheap 0.11 captures BOTH TOU off-peak (0.098) and ULO overnight (0.039) ⇒ charge; peak 0.20 captures TOU on-peak (0.203) and ULO on-peak (0.391) ⇒ discharge; TOU/ULO mid (0.157) holds. Battery thus captures the full ULO arbitrage spread (39.1−3.9 = 35.2 ¢) and TOU spread (~10.5 ¢). Home battery ~$850–1,160/kWh after the HRSP $300/kWh rebate (OEB rates eff. 2025-11-01). √η round-trip loss applied in applyBatteryTransition.",
    "cheapPerKwh": 0.11,
    "peakPerKwh": 0.2,
    "reservationMarginPerKwh": 0.01,
    "_reservationNote": "P14 C113 — the opportunity-cost margin a peak DISCHARGE must clear above the charge cost/√η before the battery commits (NREL SAM BTM dispatch SAM 55200; OSTI DES demand-charge; TheMeritOrder BESS arbitrage). Li-ion one-way η≈0.92 ⇒ RTE≈0.85 ⇒ reservation floor ≈ chargeCost/√η + this margin. 0.01 keeps the coarse peak band authoritative on legacy/golden data (η=1 ⇒ reservation = CHEAP + 0.01, well below peak 0.20 ⇒ discharge still fires on peak). source: NREL/OSTI as_of 2026-07-03."
  },
  "reserveFloorFrac": 0.2,
  "delivery": {
    "_note": "cents/kWh like every price here. retailPerKwh stays the COMMODITY (RPP, GA-recovered); these are the DELIVERY + regulatory legs paid to the transmitter / LDC / IESO. The avoidable LOCATIONAL value of a local or peer-to-neighbour kWh = transmission + wms + retail*(lineLossFactor-1) — distribution is NOT avoidable (mostly the fixed $51.18/30-day charge; distributionCentsPerKwh is an EFFECTIVE volumetric proxy at ~700 kWh/mo).",
    "source": "Toronto Hydro RTSR eff. 2026-01-01 (transmission 2.241¢/kWh); IESO UTR 2025 ($6.37/$1.00/$3.39 per kW-month); OEB WMS $0.0053/kWh; T&D loss ~4%",
    "as_of": "2026-06-15",
    "transmissionCentsPerKwh": 2.241,
    "distributionCentsPerKwh": 6.0,
    "wmsCentsPerKwh": 0.53,
    "lineLossFactor": 1.04
  },
  "oerPercent": 0.235
}
